import styled from 'styled-components'

import { theme } from 'styles/theme'

const { colors, media, space } = theme

export const Products = styled.section`
  position: relative;
  z-index: 1;
  display: flex;
  justify-content: center;
  width: 100%;
  overflow: hidden;
  background-color: ${colors['cashme-dark-blue']};
`

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  height: 100%;
  gap: ${space['spacing-md']};
  padding: ${space['spacing-xl']} 8.5rem ${space['spacing-xxl']};

  @media (${media.phone}) {
    padding: ${space['spacing-xl']} ${space['spacing-md']} ${space['spacing-xxl']};
  }
`

export const Header = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${space['spacing-md']};
  margin-bottom: ${space['spacing-sm']};

  /* tighten only the gap between the title and the subtitle (no token between
     spacing-sm and spacing-md, so a raw value) */
  h2 + p {
    margin-top: -1.25rem;
  }
`

export const TabsWrapper = styled.div`
  && button > span {
    text-transform: none;
  }

  && button[data-state='inactive'] > span {
    color: rgb(255 255 255 / 65%);
  }

  && button[data-state='active'] > span {
    color: #fff;
  }

  && .tab-indicator {
    background-color: ${colors['cyan-text-contrast']};
  }

  && > div:first-child {
    border-bottom: 1px solid rgb(255 255 255 / 20%);
  }

  @media (${media.phone}) {
    && > div:first-child {
      height: auto;
    }

    && button {
      display: inline-block;
      vertical-align: top;
      text-align: left;
    }

    && button > span {
      white-space: pre-line;
    }

    && button:not(:last-child) {
      margin-right: ${space['spacing-sm']};
    }
  }

  @media (${media.tablet}) {
    && > div:first-child {
      display: flex;
      justify-content: space-between;
      gap: ${space['spacing-md']};
    }

    && button:not(:last-child) {
      margin-right: 0;
    }
  }
`
